module.exports = __webpack_public_path__ + "static/media/7.b857cdb8.jpg";